import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { config } from '../../../config';


export const WebinarContext = createContext();

export const WebinarProvider = ({ children }) => {
  const apiUrl = config.apiUrl;
  const imageUrl = config.imageUrl;
  const { slug } = useParams();

  // সমস্ত স্টেট
  const [landingPage, setLandingPage] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // সমস্ত ডেটা ফেচ করার ফাংশন
  const fetchLandingPageData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/homepages/${slug}`);
     
      setLandingPage(response.data.homepage);
    } catch (error) {
      setError(error?.response?.data?.message || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  }, [slug, apiUrl]);

  // প্রাথমিক ডেটা লোড
  useEffect(() => {
    if (slug) {
      fetchLandingPageData();
    }
  }, [fetchLandingPageData, slug]);

  return (
    <WebinarContext.Provider
      value={{
        loading,
        error,
        imageUrl,
        slug,
        landingPage
      }}
    >
      {children}
    </WebinarContext.Provider>
  );
};